export default "__VITE_ASSET__DNe384i7__";